/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { vw_sales } from '../models/vw_sales';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SalesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get sales by id
     * @returns vw_sales The sales data
     * @throws ApiError
     */
    public getSales({
        id,
    }: {
        id: string,
    }): CancelablePromise<vw_sales> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sales/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Sales not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Revoke all transactions and set stock.
     * @returns vw_sales The sales data
     * @throws ApiError
     */
    public deleteSalesRevoke({
        id,
    }: {
        id: string,
    }): CancelablePromise<vw_sales> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/sales/revoke/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Sales not found`,
                500: `Internal server error`,
            },
        });
    }

}
